export function updateHeaderHeightVariables() {
  // Get the .site-header element
  const siteHeader = document.querySelector('.site-header');
  const headerHeight = siteHeader.offsetHeight;  // Get the height of the .site-header

  // Declare the variable outside the if statement
  let headerHeightSubmenu = 0;

  // Check if .secondary-menu exists and set its height
  const secondaryMenu = document.querySelector('.secondary-menu');
  if (secondaryMenu) {
      headerHeightSubmenu = secondaryMenu.offsetHeight;
  }
  
  // Set the CSS variables with the heights
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  document.documentElement.style.setProperty('--header-height-submenu', `${headerHeightSubmenu}px`);
}
